var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.targetLevel}},[_c('membership-card',{attrs:{"level":_vm.level,"next-level":_vm.nextLevel,"id":_vm.targetLevel}}),_vm._v(" "),_c('b-popover',{attrs:{"target":_vm.targetLevel,"triggers":"hover","placement":"bottom"}},[_c('levels-list',{attrs:{"all-levels":_vm.allLevels}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }